import React from 'react';
import { Users } from 'lucide-react';

const BetaForm = () => {
  return (
    <section className="py-20 bg-white" id="beta-form">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 bg-green-100 px-4 py-2 rounded-full text-green-800 font-medium mb-6">
            <Users className="h-5 w-5" />
            <span>Formulário de Inscrição no Beta</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
            Garante sua vaga no Beta gratuito
          </h2>
          <p className="text-xl text-slate-600">
            Preencha os dados abaixo e receba acesso imediato ao ImóvelIA
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200">
            <iframe
              src="https://tally.so/embed/mOLbvq?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              width="100%"
              height="600"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
              title="Inscrição Beta ImóvelIA - Correspondentes Bancários"
              className="rounded-lg"
            ></iframe>
          </div>

          <div className="mt-8 text-center">
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
              <h4 className="font-semibold text-blue-900 mb-2">
                Após o cadastro:
              </h4>
              <p className="text-blue-700">
                "Pronto! Você receberá uma mensagem no WhatsApp para iniciar com o ImóvelIA."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetaForm;